<template>
  <div v-if="!requisicoes.finalizado" class="loading-overlay">
    <div class="spinner"></div>
  </div>

  <div v-if="requisicoes.finalizado">
    <!-- Info Banner -->
    <div class="form-info-banner">
      <h3 class="form-info-banner-title">
        Os campos com * são de preenchimento obrigatório
      </h3>
      <p class="form-info-banner-text">
        Caso queira, você poderá salvar e continuar depois.
      </p>
    </div>

    <!-- Input de arquivo único compartilhado -->
    <input
      type="file"
      ref="fileInput"
      accept="image/*,application/pdf"
      style="display: none"
      @change="handleFileChange($event)"
    />

    <!-- Seção: Documentos Obrigatórios -->
    <section class="form-section" v-if="documentosObrigatorios.length > 0">
      <div class="form-section-header">
        <LabelDisclaimer
          :TamanhoFonteLabel="'H5'"
          :NomeLabel="'Documentos'"
          :Sessao="'Documentos'"
          :SubSessao="'Documentos'"
        />
        <h3
          class="text-base font-semibold text-gray-900 dark:text-gray-100 mt-3"
        >
          Obrigatórios
        </h3>
        <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
          Anexe os documentos a seguir:
        </p>
      </div>
      <div class="form-section-content">
        <!-- Desktop -->
        <div class="hidden md:block overflow-x-auto">
          <table
            class="min-w-full divide-y divide-gray-200 dark:divide-gray-700"
          >
            <thead class="bg-gray-50 dark:bg-gray-800">
              <tr>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                >
                  Documento
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                >
                  Arquivo Anexado
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider w-40"
                >
                  Ação
                </th>
              </tr>
            </thead>
            <tbody
              class="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700"
            >
              <template v-if="requisicoes.listaDocumentosUploadEfetuado">
                <tr
                  v-for="doc in documentosObrigatorios"
                  :key="`ob_${doc.Id}_${doc.ChaveUnica}`"
                  class="hover:bg-gray-50 dark:hover:bg-gray-800"
                >
                  <td
                    class="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100"
                  >
                    {{ doc.Nome }}
                  </td>
                  <td
                    class="px-6 py-4 text-sm text-gray-700 dark:text-gray-300"
                  >
                    <div
                      v-if="getArquivosDoDocumento(doc).length > 0"
                      class="space-y-1"
                    >
                      <div
                        v-for="arq in getArquivosDoDocumento(doc)"
                        :key="arq._key"
                        class="flex items-center gap-2"
                      >
                        <i
                          class="fa fa-file-alt text-green-500 flex-shrink-0"
                        ></i>
                        <span class="truncate max-w-xs">{{
                          arq.FileName
                        }}</span>
                        <span
                          v-if="arq._isPending"
                          class="text-xs text-blue-500 flex-shrink-0"
                          >(pendente)</span
                        >
                      </div>
                    </div>
                    <span
                      v-else
                      class="text-gray-400 dark:text-gray-500 italic text-sm"
                      >Nenhum arquivo anexado</span
                    >
                  </td>
                  <td class="px-6 py-4 text-sm">
                    <div v-if="getArquivosDoDocumento(doc).length === 0">
                      <button
                        @click.prevent="selecionarDocumento(doc)"
                        class="btn-primary py-1.5 px-3 text-sm"
                      >
                        <i class="fa fa-upload mr-1"></i> Anexar
                      </button>
                    </div>
                    <div v-else class="space-y-1">
                      <div
                        v-for="arq in getArquivosDoDocumento(doc)"
                        :key="arq._key"
                      >
                        <!-- <button
                          @click.prevent="visualizarArquivo(arq)"
                          class="flex items-center gap-1 text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 focus:outline-none"
                        >
                          <i class="fa fa-eye"></i>
                          <span>Visualizar</span>
                        </button> -->
                        <button
                          v-if="!Edicao"
                          @click.prevent="excluirArquivoDoGrid(arq)"
                          :disabled="deletando === arq._key"
                          :class="{
                            'opacity-50 cursor-not-allowed':
                              deletando === arq._key,
                          }"
                          class="flex items-center gap-1 text-red-600 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300 focus:outline-none"
                        >
                          <i
                            v-if="deletando !== arq._key"
                            class="fa fa-trash"
                          ></i>
                          <i
                            v-if="deletando === arq._key"
                            class="fa fa-spinner fa-spin"
                          ></i>
                          <span>Excluir</span>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-if="!requisicoes.listaDocumentosUploadEfetuado">
                <tr
                  v-for="i in documentosObrigatorios.length"
                  :key="'shimmer-ob-' + i"
                >
                  <td colspan="3" class="px-6 py-4">
                    <div class="shimmer h-4 w-full rounded"></div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <!-- Mobile Cards -->
        <div class="md:hidden space-y-3">
          <template v-if="requisicoes.listaDocumentosUploadEfetuado">
            <div
              v-for="doc in documentosObrigatorios"
              :key="`mob_ob_${doc.Id}_${doc.ChaveUnica}`"
              class="border border-gray-200 dark:border-slate-700 rounded-lg p-4 bg-white dark:bg-slate-800"
            >
              <p
                class="text-sm font-medium text-gray-900 dark:text-gray-100 mb-3"
              >
                {{ doc.Nome }}
              </p>
              <div
                v-if="getArquivosDoDocumento(doc).length > 0"
                class="space-y-2 mb-3"
              >
                <div
                  v-for="arq in getArquivosDoDocumento(doc)"
                  :key="arq._key"
                  class="space-y-1"
                >
                  <div
                    class="flex items-center gap-2 p-2 bg-gray-50 dark:bg-slate-700 rounded-lg"
                  >
                    <i class="fa fa-file-alt text-green-500 flex-shrink-0"></i>
                    <span
                      class="text-sm text-gray-700 dark:text-gray-300 truncate flex-1"
                      >{{ arq.FileName }}</span
                    >
                    <span
                      v-if="arq._isPending"
                      class="text-xs text-blue-500 flex-shrink-0"
                      >(pendente)</span
                    >
                  </div>
                  <button
                    @click.prevent="visualizarArquivo(arq)"
                    class="w-full px-4 py-2 text-sm font-medium text-white bg-blue-600 dark:bg-blue-700 rounded-lg hover:bg-blue-700 dark:hover:bg-blue-800 transition-colors flex items-center justify-center gap-2 mb-2"
                  >
                    <i class="fa fa-eye"></i>
                    <span>Visualizar</span>
                  </button>
                  <button
                    v-if="!Edicao"
                    @click.prevent="excluirArquivoDoGrid(arq)"
                    :disabled="deletando === arq._key"
                    :class="{
                      'opacity-50 cursor-not-allowed': deletando === arq._key,
                    }"
                    class="w-full px-4 py-2 text-sm font-medium text-white bg-red-600 dark:bg-red-700 rounded-lg hover:bg-red-700 dark:hover:bg-red-800 transition-colors flex items-center justify-center gap-2"
                  >
                    <i v-if="deletando !== arq._key" class="fa fa-trash"></i>
                    <i
                      v-if="deletando === arq._key"
                      class="fa fa-spinner fa-spin"
                    ></i>
                    <span>{{
                      deletando === arq._key
                        ? "Excluindo..."
                        : "Excluir arquivo"
                    }}</span>
                  </button>
                </div>
              </div>
              <p
                v-else
                class="text-sm text-gray-400 dark:text-gray-500 italic mb-3"
              >
                Nenhum arquivo anexado
              </p>
              <button
                v-if="getArquivosDoDocumento(doc).length === 0"
                @click.prevent="selecionarDocumento(doc)"
                class="btn-primary w-full py-2 text-sm"
              >
                <i class="fa fa-upload mr-1"></i> Anexar arquivo
              </button>
            </div>
          </template>
          <template v-if="!requisicoes.listaDocumentosUploadEfetuado">
            <div
              v-for="i in documentosObrigatorios.length"
              :key="'shimmer-mob-ob-' + i"
              class="border border-gray-200 dark:border-slate-700 rounded-lg p-4 bg-white dark:bg-slate-800"
            >
              <div class="shimmer h-4 w-3/4 rounded mb-3"></div>
              <div class="shimmer h-8 w-full rounded"></div>
            </div>
          </template>
        </div>
      </div>
    </section>

    <!-- Seção: Documentos Adicionais -->
    <section class="form-section" v-if="documentosAdicionais.length > 0">
      <div class="form-section-header">
        <h3 class="text-base font-semibold text-gray-900 dark:text-gray-100">
          Adicionais
        </h3>
        <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
          Anexe os documentos a seguir:
        </p>
      </div>
      <div class="form-section-content">
        <!-- Desktop -->
        <div class="hidden md:block overflow-x-auto">
          <table
            class="min-w-full divide-y divide-gray-200 dark:divide-gray-700"
          >
            <thead class="bg-gray-50 dark:bg-gray-800">
              <tr>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                >
                  Documento
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                >
                  Arquivo Anexado
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider w-40"
                >
                  Ação
                </th>
              </tr>
            </thead>
            <tbody
              class="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700"
            >
              <template v-if="requisicoes.listaDocumentosUploadEfetuado">
                <tr
                  v-for="doc in documentosAdicionais"
                  :key="`ad_${doc.Id}_${doc.ChaveUnica}`"
                  class="hover:bg-gray-50 dark:hover:bg-gray-800"
                >
                  <td
                    class="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100"
                  >
                    {{ doc.Nome }}
                  </td>
                  <td
                    class="px-6 py-4 text-sm text-gray-700 dark:text-gray-300"
                  >
                    <div
                      v-if="getArquivosDoDocumento(doc).length > 0"
                      class="space-y-1"
                    >
                      <div
                        v-for="arq in getArquivosDoDocumento(doc)"
                        :key="arq._key"
                        class="flex items-center gap-2"
                      >
                        <i
                          class="fa fa-file-alt text-green-500 flex-shrink-0"
                        ></i>
                        <span class="truncate max-w-xs">{{
                          arq.FileName
                        }}</span>
                        <span
                          v-if="arq._isPending"
                          class="text-xs text-blue-500 flex-shrink-0"
                          >(pendente)</span
                        >
                      </div>
                    </div>
                    <span
                      v-else
                      class="text-gray-400 dark:text-gray-500 italic text-sm"
                      >Nenhum arquivo anexado</span
                    >
                  </td>
                  <td class="px-6 py-4 text-sm">
                    <div v-if="getArquivosDoDocumento(doc).length === 0">
                      <button
                        @click.prevent="selecionarDocumento(doc)"
                        class="btn-primary py-1.5 px-3 text-sm"
                      >
                        <i class="fa fa-upload mr-1"></i> Anexar
                      </button>
                    </div>
                    <div v-else class="space-y-1">
                      <div
                        v-for="arq in getArquivosDoDocumento(doc)"
                        :key="arq._key"
                      >
                        <button
                          @click.prevent="visualizarArquivo(arq)"
                          class="flex items-center gap-1 text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 focus:outline-none"
                        >
                          <i class="fa fa-eye"></i>
                          <span>Visualizar</span>
                        </button>
                        <button
                          v-if="!Edicao"
                          @click.prevent="excluirArquivoDoGrid(arq)"
                          :disabled="deletando === arq._key"
                          :class="{
                            'opacity-50 cursor-not-allowed':
                              deletando === arq._key,
                          }"
                          class="flex items-center gap-1 text-red-600 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300 focus:outline-none"
                        >
                          <i
                            v-if="deletando !== arq._key"
                            class="fa fa-trash"
                          ></i>
                          <i
                            v-if="deletando === arq._key"
                            class="fa fa-spinner fa-spin"
                          ></i>
                          <span>Excluir</span>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-if="!requisicoes.listaDocumentosUploadEfetuado">
                <tr
                  v-for="i in documentosAdicionais.length"
                  :key="'shimmer-ad-' + i"
                >
                  <td colspan="3" class="px-6 py-4">
                    <div class="shimmer h-4 w-full rounded"></div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <!-- Mobile Cards -->
        <div class="md:hidden space-y-3">
          <template v-if="requisicoes.listaDocumentosUploadEfetuado">
            <div
              v-for="doc in documentosAdicionais"
              :key="`mob_ad_${doc.Id}_${doc.ChaveUnica}`"
              class="border border-gray-200 dark:border-slate-700 rounded-lg p-4 bg-white dark:bg-slate-800"
            >
              <p
                class="text-sm font-medium text-gray-900 dark:text-gray-100 mb-3"
              >
                {{ doc.Nome }}
              </p>
              <div
                v-if="getArquivosDoDocumento(doc).length > 0"
                class="space-y-2 mb-3"
              >
                <div
                  v-for="arq in getArquivosDoDocumento(doc)"
                  :key="arq._key"
                  class="space-y-1"
                >
                  <div
                    class="flex items-center gap-2 p-2 bg-gray-50 dark:bg-slate-700 rounded-lg"
                  >
                    <i class="fa fa-file-alt text-green-500 flex-shrink-0"></i>
                    <span
                      class="text-sm text-gray-700 dark:text-gray-300 truncate flex-1"
                      >{{ arq.FileName }}</span
                    >
                    <span
                      v-if="arq._isPending"
                      class="text-xs text-blue-500 flex-shrink-0"
                      >(pendente)</span
                    >
                  </div>
                  <button
                    @click.prevent="visualizarArquivo(arq)"
                    class="w-full px-4 py-2 text-sm font-medium text-white bg-blue-600 dark:bg-blue-700 rounded-lg hover:bg-blue-700 dark:hover:bg-blue-800 transition-colors flex items-center justify-center gap-2 mb-2"
                  >
                    <i class="fa fa-eye"></i>
                    <span>Visualizar</span>
                  </button>
                  <button
                    v-if="!Edicao"
                    @click.prevent="excluirArquivoDoGrid(arq)"
                    :disabled="deletando === arq._key"
                    :class="{
                      'opacity-50 cursor-not-allowed': deletando === arq._key,
                    }"
                    class="w-full px-4 py-2 text-sm font-medium text-white bg-red-600 dark:bg-red-700 rounded-lg hover:bg-red-700 dark:hover:bg-red-800 transition-colors flex items-center justify-center gap-2"
                  >
                    <i v-if="deletando !== arq._key" class="fa fa-trash"></i>
                    <i
                      v-if="deletando === arq._key"
                      class="fa fa-spinner fa-spin"
                    ></i>
                    <span>{{
                      deletando === arq._key
                        ? "Excluindo..."
                        : "Excluir arquivo"
                    }}</span>
                  </button>
                </div>
              </div>
              <p
                v-else
                class="text-sm text-gray-400 dark:text-gray-500 italic mb-3"
              >
                Nenhum arquivo anexado
              </p>
              <button
                v-if="getArquivosDoDocumento(doc).length === 0"
                @click.prevent="selecionarDocumento(doc)"
                class="btn-primary w-full py-2 text-sm"
              >
                <i class="fa fa-upload mr-1"></i> Anexar arquivo
              </button>
            </div>
          </template>
          <template v-if="!requisicoes.listaDocumentosUploadEfetuado">
            <div
              v-for="i in documentosAdicionais.length"
              :key="'shimmer-mob-ad-' + i"
              class="border border-gray-200 dark:border-slate-700 rounded-lg p-4 bg-white dark:bg-slate-800"
            >
              <div class="shimmer h-4 w-3/4 rounded mb-3"></div>
              <div class="shimmer h-8 w-full rounded"></div>
            </div>
          </template>
        </div>
      </div>
    </section>

    <Dialog
      v-model:visible="previewDialogVisible"
      :header="previewFileName"
      :modal="true"
      :closable="true"
      :draggable="false"
      :style="{ width: '90vw', height: '90vh' }"
      :breakpoints="{ '960px': '90vw' }"
      @hide="fecharPreview"
    >
      <div v-if="previewLoading" class="flex justify-center items-center py-8">
        <ProgressSpinner style="width: 50px; height: 50px" />
      </div>
      <div
        v-else-if="isPreviewPdf"
        class="w-full"
        :style="{ height: 'calc(90vh - 120px)' }"
      >
        <iframe
          :src="previewSrc"
          class="w-full h-full"
          style="border: none"
        ></iframe>
      </div>
      <img
        v-else
        :src="previewSrc"
        class="max-w-full max-h-full mx-auto object-contain"
        :style="{ maxHeight: 'calc(90vh - 120px)' }"
      />
    </Dialog>

    <ModalAlerta
      v-if="modalAlerta.mostrar"
      :mostrar="modalAlerta.mostrar"
      :tipo="modalAlerta.tipo"
      :titulo="modalAlerta.titulo"
      :mensagem="modalAlerta.mensagem"
      @fechar="modalAlerta.mostrar = false"
    />
  </div>
</template>

<script>
import api from "@/api/axios";
import { mapGetters } from "vuex";
import formatData from "@/utils/formatData";
import LabelDisclaimer from "@/components/LabelDisclaimer.vue";
import ModalAlerta from "../Utilitarios/ModalAlerta.vue";
import Dialog from "primevue/dialog";
import ProgressSpinner from "primevue/progressspinner";
import { TIPO_CLIENTE } from "@/constants/TipoClienteEnum";

export default {
  mixins: [formatData],
  components: { LabelDisclaimer, ModalAlerta, Dialog, ProgressSpinner },
  name: "UploadDocumentosShared",
  props: {
    Edicao: Boolean,
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      listaDocumentos: "GET_LISTA_DOCUMENTOS_UPLOAD",
      listaDocumentosUploadEfetuado: "GET_LISTA_DOCUMENTOS_UPLOAD_REALIZADO",
    }),
    tipoCliente() {
      return this.user?.TipoCliente;
    },
    documentosObrigatorios() {
      return (this.listaDocumentos || []).filter(
        (doc) => doc.Obrigatorio === "Sim",
      );
    },
    documentosAdicionais() {
      return (this.listaDocumentos || []).filter(
        (doc) => doc.Obrigatorio !== "Sim",
      );
    },
    configTipo() {
      return {
        [TIPO_CLIENTE.PESSOA_FISICA]: {
          storeMutation: "SET_PF_SALVAR_INFO",
          proximaEtapa: 6,
        },
        [TIPO_CLIENTE.PESSOA_JURIDICA]: {
          storeMutation: "SET_PJ_SALVAR_INFO",
          proximaEtapa: 7,
        },
        [TIPO_CLIENTE.INSTITUCIONAL]: {
          storeMutation: "SET_PJ_SALVAR_INFO",
          proximaEtapa: 7,
        },
        [TIPO_CLIENTE.FUNDOS]: {
          storeMutation: "SET_FI_SALVAR_INFO",
          proximaEtapa: 6,
        },
      }[this.tipoCliente];
    },
    isPreviewPdf() {
      return this.previewFileName?.toLowerCase().endsWith(".pdf");
    },
  },
  data() {
    return {
      modalAlerta: {
        mostrar: false,
        tipo: "warning",
        titulo: "",
        mensagem: "",
      },
      permitirAvancar: false,
      currentDocumento: null,
      deletando: null,
      requisicoes: {
        listaDocumentos: false,
        listaDocumentosUploadEfetuado: false,
        finalizado: false,
      },
      arquivosUpload: [],
      arquivos: [],
      previewDialogVisible: false,
      previewSrc: "",
      previewFileName: "",
      previewLoading: false,
      previewToken: 0,
    };
  },
  created() {
    this.$store.dispatch("FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD");
    this.$store.dispatch("FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO");
  },
  mounted() {
    this.executarListagemUploads();
  },
  watch: {
    listaDocumentosUploadEfetuado() {
      this.executarListagemUploads();
    },
    listaDocumentos() {
      this.verificarSeRequisicoesFinalizaram("listaDocumentos");
    },
  },
  methods: {
    executarListagemUploads() {
      this.verificarSeRequisicoesFinalizaram("listaDocumentos");
      this.verificarSeRequisicoesFinalizaram("listaDocumentosUploadEfetuado");
      if (this.listaDocumentosUploadEfetuado != null) {
        this.arquivosUpload = [];
        this.arquivos = this.listaDocumentosUploadEfetuado;
      }
      this.validarFormulario();
    },
    verificarSeRequisicoesFinalizaram(requisicao) {
      if (requisicao == "listaDocumentos") {
        this.requisicoes.listaDocumentos = true;
      } else if (requisicao == "listaDocumentosUploadEfetuado") {
        this.requisicoes.listaDocumentosUploadEfetuado = true;
      }

      if (
        this.requisicoes.listaDocumentosUploadEfetuado &&
        this.requisicoes.listaDocumentos
      ) {
        this.requisicoes.finalizado = true;
      }
    },
    getTipoPessoa() {
      const tipoCliente = this.user?.TipoCliente;
      if (typeof tipoCliente === "number") return tipoCliente;
      if (tipoCliente === TIPO_CLIENTE.PESSOA_FISICA) return 1;
      if (tipoCliente === TIPO_CLIENTE.PESSOA_JURIDICA) return 2;
      if (tipoCliente === TIPO_CLIENTE.FUNDOS) return 3;
      if (tipoCliente === TIPO_CLIENTE.INSTITUCIONAL) return 4;
      return null;
    },
    parseDocumentoInfo(documento) {
      return {
        DocumentoId: documento.Id,
        NomeDocumento: documento.Nome,
        NomePessoa:
          documento.IdPessoa > 0
            ? (documento.Nome || "").split(" - ").slice(1).join(" - ").trim() ||
              null
            : null,
        IdPessoa: documento.IdPessoa || null,
        TipoPessoa: this.getTipoPessoa(),
        IdNomeDocumento: documento.IdNomeDocumento || null,
        ChaveUnica: documento.ChaveUnica || null,
      };
    },
    documentoMatchKey(doc) {
      if (doc.ChaveUnica)
        return `${doc.DocumentoId || doc.Id}_${doc.ChaveUnica}`;
      return `${doc.DocumentoId || doc.Id}_${
        doc.NomeDocumento || doc.Nome || ""
      }`;
    },
    matchesDoc(arquivo, doc) {
      const docKey = doc.ChaveUnica
        ? `${doc.Id}_${doc.ChaveUnica}`
        : `${doc.Id}_${doc.Nome}`;
      const arqKey = this.documentoMatchKey(arquivo);
      return (
        arqKey === docKey ||
        arquivo.NomeDocumento === doc.Nome ||
        arquivo.Nome === doc.Nome
      );
    },
    getArquivosDoDocumento(doc) {
      const result = [];
      this.arquivos.forEach((arq, i) => {
        if (this.matchesDoc(arq, doc)) {
          result.push({
            ...arq,
            _key: `saved_${i}`,
            _isPending: false,
            _savedIndex: i,
          });
        }
      });
      this.arquivosUpload.forEach((arq, i) => {
        if (this.matchesDoc(arq, doc)) {
          result.push({
            ...arq,
            _key: `pending_${i}`,
            _isPending: true,
            _pendingIndex: i,
          });
        }
      });
      return result;
    },
    selecionarDocumento(doc) {
      this.currentDocumento = doc;
      this.triggerFileInput();
    },
    excluirArquivoDoGrid(arq) {
      if (arq._isPending) {
        this.removerArquivoPendente(arq._pendingIndex);
      } else {
        const original = this.arquivos[arq._savedIndex];
        this.excluirArquivo(original, arq._key);
      }
    },
    validarFormulario(submeter) {
      if (!this.listaDocumentos || this.listaDocumentos.length === 0) {
        if (submeter) {
          this.modalAlerta = {
            mostrar: true,
            tipo: "warning",
            titulo: "Aguarde",
            mensagem: "Carregando lista de documentos...",
          };
        }
        return false;
      }

      this.permitirAvancar = true;
      let nomeDoCampo = "";

      this.listaDocumentos.forEach((obj) => {
        if (obj.Obrigatorio === "Sim") {
          const chaveRequerida = obj.ChaveUnica
            ? `${obj.Id}_${obj.ChaveUnica}`
            : `${obj.Id}_${obj.Nome || ""}`;

          const temArquivoSalvo = this.arquivos.some((arquivo) => {
            const chaveArquivo = this.documentoMatchKey(arquivo);
            return (
              chaveArquivo === chaveRequerida ||
              arquivo.NomeDocumento === obj.Nome ||
              arquivo.Nome === obj.Nome
            );
          });

          const temArquivoPendente = this.arquivosUpload.some((arquivo) => {
            const chaveArquivo = this.documentoMatchKey(arquivo);
            return (
              chaveArquivo === chaveRequerida ||
              arquivo.NomeDocumento === obj.Nome ||
              arquivo.Nome === obj.Nome
            );
          });

          if (!temArquivoSalvo && !temArquivoPendente) {
            if (this.permitirAvancar) {
              nomeDoCampo = obj.Nome;
            }
            this.permitirAvancar = false;
          }
        }
      });

      if (submeter && nomeDoCampo != "") {
        this.modalAlerta = {
          mostrar: true,
          tipo: "warning",
          titulo: "Atenção: Documento obrigatório",
          mensagem: `O documento ${nomeDoCampo} é obrigatório e não foi enviado, envie o documento para avançar`,
        };
      }

      return this.permitirAvancar;
    },
    proximaEtapa() {
      if (this.validarFormulario(true)) {
        if (this.arquivosUpload && this.arquivosUpload.length > 0) {
          this.requisicoes.listaDocumentosUploadEfetuado = false;
        }
        this.$store.commit("SET_SALVAR_INFO_DES_NOTIFICACAO", true);
        this.$store.commit(this.configTipo.storeMutation, true);
        this.$store.commit("SET_ETAPA_CADASTRO", this.configTipo.proximaEtapa);
      }
    },
    triggerFileInput() {
      if (!this.$refs.fileInput) return;

      const fileInput = this.$refs.fileInput;
      const originalDisplay = fileInput.style.display;

      fileInput.style.display = "block";
      fileInput.style.position = "absolute";
      fileInput.style.opacity = "0.01";
      fileInput.style.zIndex = "9999";

      setTimeout(() => {
        const event = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
        });
        fileInput.dispatchEvent(event);

        setTimeout(() => {
          fileInput.style.display = originalDisplay;
        }, 200);
      }, 50);
    },
    async excluirArquivo(arquivo, key) {
      this.deletando = key;

      await api
        .post(`/cliente/documentos/excluir`, arquivo)
        .then((retorno) => {
          this.deletando = null;

          if (retorno.status == 200) {
            this.$store.dispatch(
              "FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO",
            );

            this.$swal({
              icon: "success",
              title: "Exclusão realizada com sucesso!",
              text: "Arquivo informado foi excluído.",
            });

            this.validarFormulario();
          } else {
            this.$swal({
              icon: "error",
              title: "Erro",
              text: `Falha ao realizar exclusão do arquivo.`,
            });
          }
        })
        .catch((error) => {
          this.deletando = null;
          this.$swal({
            icon: "error",
            title: "Falha ao realizar exclusão do arquivo.",
            text: `${error.response.data.data[0]}`,
          });
        });

      this.validarFormulario();
    },
    salvarAlteracoesLocalmente() {
      try {
        this.$store.commit("SET_SALVAR_INFO_UPLOAD", this.arquivosUpload);
        this.validarFormulario();

        if (!this.Edicao) {
          this.$store.commit("SET_SALVAR_INFO_DES_NOTIFICACAO", true);
          this.salvar();
        } else {
          if (this.arquivosUpload && this.arquivosUpload.length > 0) {
            this.salvarInformacoes();
          }
        }
      } catch (error) {
        console.error("Erro ao salvar alterações localmente:", error);
        this.$swal({
          icon: "error",
          title: "Erro",
          text: error.message,
        });
      }
    },
    removerArquivoPendente(index) {
      this.arquivosUpload.splice(index, 1);
      this.$store.commit("SET_SALVAR_INFO_UPLOAD", this.arquivosUpload);
      this.validarFormulario();
    },
    salvar() {
      this.$store.commit(this.configTipo.storeMutation, true);
    },
    async salvarInformacoes() {
      const filesToUpload =
        this.arquivosUpload.length > 0
          ? this.arquivosUpload
          : this.$store.getters["GET_SALVAR_INFO_UPLOAD"];

      if (!filesToUpload || filesToUpload.length === 0) {
        return true;
      }

      try {
        await api.post("/cliente/documentos", { documentos: filesToUpload });
        this.arquivosUpload = [];
        this.$store.commit("SET_SALVAR_INFO_UPLOAD", null);
        this.$store.dispatch(
          "FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO",
        );
        return true;
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Erro ao salvar",
          text:
            error.response?.data?.data?.[0] ??
            "Erro ao enviar os documentos. Tente novamente.",
        });
        return false;
      }
    },
    visualizarArquivo(arq) {
      if (this.previewSrc?.startsWith("blob:")) {
        window.URL.revokeObjectURL(this.previewSrc);
      }
      this.previewSrc = "";
      this.previewToken++;
      const token = this.previewToken;
      this.previewFileName = arq.FileName;

      if (arq._isPending) {
        const mimeType = this.getMimeType(arq.FileName);
        this.previewSrc = `data:${mimeType};base64,${arq.FileDataString64}`;
        this.previewDialogVisible = true;
      } else {
        this.previewLoading = true;
        this.previewDialogVisible = true;
        this.$store
          .dispatch("FETCH_BAIXAR_DOCUMENTO_CLIENTE", arq.Id)
          .then((response) => {
            if (token !== this.previewToken) return;
            const contentType =
              response.headers["content-type"] || "application/octet-stream";
            const blob = new Blob([response.data], { type: contentType });
            this.previewSrc = window.URL.createObjectURL(blob);
          })
          .catch(() => {
            if (token !== this.previewToken) return;
            this.previewDialogVisible = false;
            this.$swal({
              icon: "error",
              title: "Erro",
              text: "Não foi possível carregar o documento para visualização.",
            });
          })
          .finally(() => {
            if (token !== this.previewToken) return;
            this.previewLoading = false;
          });
      }
    },
    getMimeType(fileName) {
      const ext = fileName?.split(".").pop()?.toLowerCase();
      const map = {
        pdf: "application/pdf",
        png: "image/png",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        gif: "image/gif",
        bmp: "image/bmp",
        webp: "image/webp",
      };
      return map[ext] || "application/octet-stream";
    },
    fecharPreview() {
      if (this.previewSrc?.startsWith("blob:")) {
        window.URL.revokeObjectURL(this.previewSrc);
      }
      this.previewSrc = "";
      this.previewFileName = "";
      this.previewLoading = false;
      this.previewDialogVisible = false;
    },
    handleFileChange(event) {
      const file = event.target.files[0];

      if (!file) {
        console.error("Nenhum arquivo selecionado");
        return;
      }

      if (!this.currentDocumento) {
        this.$swal({
          icon: "warning",
          title: "Documento não selecionado",
          text: "Selecione o tipo de documento antes de anexar o arquivo.",
        });
        return;
      }

      const fileName = file.name;
      const documentoInfo = this.parseDocumentoInfo(this.currentDocumento);
      const reader = new FileReader();

      reader.onerror = (error) => {
        console.error("Erro ao ler o arquivo:", error);
        this.$swal({
          icon: "error",
          title: "Erro no upload",
          text: "Houve um problema ao processar o arquivo. Por favor, tente novamente.",
        });
      };

      reader.onabort = () => {
        console.warn("Leitura de arquivo cancelada");
      };

      reader.onload = (e) => {
        try {
          const base64String = e.target.result;

          if (typeof base64String !== "string") {
            throw new Error("Resultado inválido da leitura do arquivo");
          }

          let base64Data = base64String;
          if (base64String.includes(",")) {
            base64Data = base64String.split(",")[1];
          }

          const novoArquivo = {
            ClienteId: this.user.ClienteId,
            DocumentoId: documentoInfo.DocumentoId,
            TipoDocumentoId: documentoInfo.DocumentoId,
            NomeDocumento: documentoInfo.NomeDocumento,
            NomePessoa: documentoInfo.NomePessoa,
            TipoPessoa: documentoInfo.TipoPessoa,
            IdPessoa: documentoInfo.IdPessoa,
            IdNomeDocumento: documentoInfo.IdNomeDocumento,
            ChaveUnica: documentoInfo.ChaveUnica,
            FileName: fileName,
            Descricao: "",
            FileDataString64: base64Data,
            UsuarioInsert: this.user.NomeRazaoSocial,
            timestamp: new Date().getTime(),
          };

          this.arquivosUpload.push({ ...novoArquivo });
          this.currentDocumento = null;
          this.salvarAlteracoesLocalmente();
        } catch (error) {
          console.error("Erro ao processar arquivo:", error);
          this.$swal({
            icon: "error",
            title: "Erro no processamento",
            text: "Não foi possível processar o arquivo selecionado.",
          });
        }
      };

      setTimeout(() => {
        reader.readAsDataURL(file);
      }, 100);

      setTimeout(() => {
        event.target.value = null;
      }, 200);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap");
</style>
